import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const InvoiceDetails = ({
  legalName, setLegalName,
  legalAddress, setLegalAddress,
  invoiceEmail, setInvoiceEmail,
  onSave, onPrev, onNext,
}) => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm({
    defaultValues: { legalName: '', legalAddress: '', invoiceEmail: '' }
  });

  useEffect(() => {
    setValue('legalName',    legalName    || '');
    setValue('legalAddress', legalAddress || '');
    setValue('invoiceEmail', invoiceEmail || '');
  }, [legalName, legalAddress, invoiceEmail, setValue]);

  return (
    <div className="tab-content">
      <h1>Invoice Details</h1>
      <p className="tab-description">
        Used for generating invoices. All fields are required.
      </p>
      <form onSubmit={handleSubmit(onSave)} className="business-form">

        <div className="form-group">
          <label htmlFor="legalName">Legal name <span className="req">*</span></label>
          <input
            type="text"
            id="legalName"
            placeholder="Registered legal name"
            value={legalName}
            {...register('legalName', {
              required: 'Legal name is required',
              onChange: (e) => setLegalName(e.target.value)
            })}
          />
          {errors.legalName && <span className="error-text">{errors.legalName.message}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="legalAddress">Legal address <span className="req">*</span></label>
          <input
            type="text"
            id="legalAddress"
            placeholder="Registered address"
            value={legalAddress}
            {...register('legalAddress', {
              required: 'Legal address is required',
              onChange: (e) => setLegalAddress(e.target.value)
            })}
          />
          {errors.legalAddress && <span className="error-text">{errors.legalAddress.message}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="invoiceEmail">Invoice email <span className="req">*</span></label>
          <input
            type="email"
            id="invoiceEmail"
            placeholder="invoices@yourorg.com"
            value={invoiceEmail}
            {...register('invoiceEmail', {
              required: 'Invoice email is required',
              pattern: { value: /^\S+@\S+\.\S+$/, message: 'Enter a valid email' },
              onChange: (e) => setInvoiceEmail(e.target.value)
            })}
          />
          {errors.invoiceEmail && <span className="error-text">{errors.invoiceEmail.message}</span>}
        </div>

        <div className="form-navigation">
          <button type="button" onClick={onPrev}>← Previous</button>
          <button type="submit">Save</button>
          <button type="button" onClick={onNext}>Next →</button>
        </div>
      </form>
    </div>
  );
};

export default InvoiceDetails;
